import { RandomUtils } from './random-utils';

/**
 * Erzeugt die `booking_reference` einer Buchung: den Zeiger, über den die
 * Büroware zusammengehörige Movements erkennt.
 */
export class BookingReference {
  /**
   * Referenz einer auftragsbezogenen Buchung, deterministisch aus der
   * Auftragsnummer: alle Movements desselben Auftrags teilen dieselbe Referenz,
   * auch über Speichervorgänge, Offline und Neustart hinweg (kein Gerätestatus).
   *
   * @param orderNumber Auftragsnummer des zugehörigen Auftrags
   * @returns Referenz der Form `Order <Auftragsnummer>`
   */
  public static forOrder(orderNumber: string): string {
    return `Order ${orderNumber}`;
  }

  /**
   * Referenz einer auftragslosen (Ad-hoc-)Buchung, z.B. KFZ→KFZ oder
   * Bufferstock→Bufferstock. Frisch erzeugt pro Buchung; da eine Ad-hoc-Buchung
   * in genau einem Submit passiert, gruppiert das ihre Movements korrekt.
   *
   * @returns Referenz der Form `Transfer <uuid>`
   */
  public static forTransfer(): string {
    return `Transfer ${RandomUtils.uuid()}`;
  }
}
